<template>

    <template v-if="type == 'nav-superiore'">
        <li v-for="item in items" v-show="$root.isMenuItemVisibile(item)" :key="item.ID_MENU" :class="item.FLG_TIPOLOGIA == 3 ? 'nav-item' : 'nav-item dropdown ms-xl-1'">
            <template v-if="item.FLG_TIPOLOGIA == 3">
                <span class="navbar-nav-link text-muted text-uppercase fs-sm px-2 disabled">{{ item.DESCRIZIONE }}</span>
            </template>
            <template v-else-if="item.children && item.children.length">
                <a v-if="item.FLG_TIPOLOGIA == 1" href="#" class="navbar-nav-link rounded dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" @click.prevent="$emit('route-click', item.ROUTE || '#')">
                    <div v-html="item.ICONA"></div>{{ item.DESCRIZIONE }}
                </a>
                <div v-else class="dropdown-divider"></div>

                <div class="dropdown-menu">
                    <SubMenu
                        v-for="child in item.children"
                            :key="child.ID_MENU"
                            :item="child"
                            :type = "type"
                            @route-click="onRouteClick">
                    </SubMenu>
                </div>
            </template>
            <template v-else>
                <a href="#" class="navbar-nav-link rounded" @click.prevent="$emit('route-click', item.ROUTE || '#')">
                    <div v-html="item.ICONA"></div>{{ item.DESCRIZIONE }}
                </a>
        </template>
        </li>
    </template>

    <template v-else-if="type == 'nav-laterale'">
        <template v-for="item in items" :key="item.ID_MENU">
            <li v-if="item.FLG_TIPOLOGIA == 3" v-show="$root.isMenuItemVisibile(item)" class="nav-item-header">
                <div class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide">{{ item.DESCRIZIONE }}</div>
                <i class="ph-dots-three sidebar-resize-show"></i>
            </li>
            <li v-else v-show="$root.isMenuItemVisibile(item)" class="nav-item" :class="{'nav-item-submenu': item.children?.length, 'nav-item-open': openMenus[item.ID_MENU]}">
                <a
                    v-show="item.FK_ID_LIVELLO == this.$root.utente.FK_ID_LIVELLO || item.FK_ID_LIVELLO == 0"
                    href="#"
                    class="nav-link"
                    :data-bs-toggle="item.children?.length ? 'collapse' : undefined"
                    :data-bs-target="item.children?.length ? '#menu-' + item.ID_MENU : undefined"
                    @click.prevent="item.children?.length ? toggleMenu(item.ID_MENU) : $emit('route-click', item.ROUTE || '#')"
                >
                    <div v-html="item.ICONA"></div><span>{{ item.DESCRIZIONE }}</span>
                </a>
                <ul :id="'menu-' + item.ID_MENU" v-if="item.children?.length" class="nav-group-sub collapse" :class="{'show': openMenus[item.ID_MENU]}">
                    <SubMenu
                        v-for="child in item.children"
                        :key="child.ID_ITEM"
                        :item="child"
                        :type="type"
                        @route-click="onRouteClick">
                    </SubMenu>
                </ul>
            </li>
        </template>
    </template>
</template>
  
<script>
import SubMenu from "@/components/utils/SubMenu.vue";


export default {

    name: "MenuRoot",

    emits: ['route-click'],

    components: {
        SubMenu,
    },

    props: {
        items: {
            type: Array,
            required: true,
        },
        type: {
            type: String,
            default: 'nav-superiore',
        },
    },

    data() {
        return {
            openMenus: {}
        };
    },

    methods: {
        onRouteClick(route) {
            this.$emit("route-click", route);
        },
        toggleMenu(id) {
            this.openMenus[id] = !this.openMenus[id];
        },
    },

    watch: {
        items: {
            immediate: true,
            handler(newItems) {
                newItems.forEach(item => {
                    if (item.children?.length && this.openMenus[item.ID_MENU] === undefined) {
                        this.openMenus[item.ID_MENU] = item.FLG_APERTO !== 0;
                    }
                });
            }
        }
    },

}
</script>

<style>
   
    
.dropdown-submenu:hover > .dropdown-menu {
    display: block;
}
    
   
</style>
